export const useListOfTags = (maxTagsToShow, tags) => {
  const numberOfExcedent = Math.max(tags.length - maxTagsToShow, 0);

  return { numberOfExcedent };
};
